<template>
  <div class="page-content" style="margin: 0px; width: 100%;">
    <v-container class="subprimary">
      <v-layout justify-start row>
        <h1>{{mainpage.title}}</h1>
        <vue-headful
          :description=mainpage.title
          :title=mainpage.title
        />
      </v-layout>
      <v-divider></v-divider>
      <v-layout justify-start row>
        <breadcrumbs style="padding-top: 6px"></breadcrumbs>
      </v-layout>
    </v-container>
    <OpenDiss v-if="$route.name === 'OpenDiss'"></OpenDiss>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import OpenDiss from './OpenDiss'
  import urls from "../../../modules/petition/urls"
  import UserDataMixin from "../../../mixins/UserDataMixin";
  import {makeGetRequest, isAuthenticated, getUserUid} from "../../../helper";
  import store from "../../../store";

  export default {
    name: "DissBreadcrumbs",
    components: {OpenDiss},
    mixins: [UserDataMixin],
    data: function () {
      return {}
    },
    computed: mapState({
      mainpage: state => state.mainpage,
    }),
    methods: {
      loadPermission(){
        makeGetRequest(process.env.VUE_APP_INSTANCE_PERMISSIONS)
          .then(resp => resp.json())
          .then(data => {
            store.commit('permissions/appendPermission', data);
          });
      },

      loadmenu() {

        // let url = new URL(urls.getUrl('admin|permissions|worker_role-list', 'list'));
        let url = new URL(urls.getUrl('public|permissions|get_user_roles', 'get'));
        let params = {};
        // params.worker__uid = getUserUid();

        url.search = new URLSearchParams(params).toString();
        if (this.$route.params.token) {
          this.$store.dispatch('user/AUTH_GUESTTOKEN', this.$route.params.token)
          if(!store.getters['permissions/checkAlreadyLoaded'])
            this.loadPermission()
        }else {
          this.$store.dispatch('user/CLEAR_GUESTTOKEN')
        }
        let sys = true
        makeGetRequest(url).then(resp => {
          if (!resp.ok) {
            sys = false
          }
          return resp.json()
        }).then(json => {
          let data = json
          if (sys)
            if (Array.isArray(data))
              if (data.length > 0) {
                this.$store.dispatch('user/AUTH_ROLE', data)
                let paramR = {}
                if (this.$route.params.token) {
                  paramR = {'token': this.$route.params.token}
                }
                let menu = []
                if (data.find( currentValue => (currentValue == Number(0) || (currentValue == Number(2)))))
                  menu.push({title: 'Создать заявку', icon: 'add_box', router: {name: 'CreateApplication', params: paramR}})
                menu.push(
                  {title: 'Шаблоны документов', icon: 'watch_later', router: {name: 'TemplatesDocs', params: paramR}},
                  {title: 'Заявки АтД', icon: 'work', router: {name: 'ListProgressApplications', params: paramR}},
                  {title: 'Архив АтД', icon: 'archive', router: {name: 'ListArchivedApplications', params: paramR}},
                  {title: 'Список дисс советов',icon: 'view_headline', router: {name: 'ListDissSovet', params: paramR}},
                  {title: 'Список диссертаций', icon: 'view_list', router: {name: 'OpenDiss', params: paramR}},
                )
                if (data.find( currentValue => (Number(currentValue) === 2 || Number(currentValue) === 0)))
                  menu.push({ title: 'Администрирование', icon: 'settings_applications', router: {name: 'AdminPage', params: paramR}})
                this.$store.commit('leftmenu/replaceItems', menu);
              }
        })


      }

    },
    beforeRouteEnter(to, from, next) {

      next(vm => {
        if (to.params.token) {
          localStorage.removeItem('user-token');
          localStorage.removeItem('isWorker');
          localStorage.removeItem('username');
          window.$cookies.remove("userMuctr");
          vm.$store.commit('user/AUTH_LOGOUT')
        }else{
          localStorage.removeItem('guest-token');
        }
      })
    },
    created() {

      let paramR = {}
      if (this.$route.params.token) {
        paramR = {'token': this.$route.params.token}
      }

      this.$store.commit('leftmenu/selectInstance', 'diss');//ListUsers
      this.$store.commit('mainpage/changeTitle', 'Ходатайство о подачи заявки на создание диссертационного совета');

      let menu = [
        {title: 'Список диссертаций', icon: 'view_list', router: 'OpenDiss'},
      ];

      this.$store.commit('leftmenu/replaceItems', menu);

      let instances = [
        {title: 'Диссертационные дела', icon: 'date_range', router: {name: 'OpenDiss', params: paramR}, name: 'diss',},
      ];
      //часть только зареганных
      if (isAuthenticated())
        instances.push({
          title: 'Диссертационные советы',
          icon: 'calendar_today',
          router: 'PetitionBreadcrumbs',
          name: 'petition',
        })

      this.$store.commit('leftmenu/replaceInstances', instances);

      if (isAuthenticated() || this.$route.params.token) {
        this.$store.commit('leftmenu/enableLeftMenu');
        this.loadmenu()
      } else {
        this.$store.commit('leftmenu/dissable');
      }

    },


  }
</script>

<style scoped>


</style>
